module.exports = __webpack_public_path__ + "h5/img/0.02@2x.e0515651.png";